import { T_ACTION_BY_SOCKET } from "@/stores/dataManager/Actions/appAction"
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit"


const initialState: any = {
    started: false,
    theme: "dark",
    language: "vi",
    token: null,
    userInfo: {},
    accounts: [],
    saveVerify: false,
    socketRegisAction: {},
    statusRegisterMF: null,
    socketStatus: null,
    setCosInfoStatus: false,
    cosInfo: {
        "cosrole": "N",
        "linkaccount": null,
        "refaccount": null,
        "custodycd": null,
        "cosrole_desc": null,
        "fullname": null,
        "status": null
    },
    cosConfig: {},
    stateLoading: false,
    msgSocketRegister: null,
    industry: [],

    mgsNotificationBySocket: null,
    statusNotificationBySocket: null,
    featureSocketListener: null
}

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        initApp: (state, action: PayloadAction<any>) => {
            state.theme = action.payload.theme
            state.language = action.payload.language
            state.token = action.payload.token
            state.userInfo = action.payload.userInfo
            state.accounts = action.payload.accounts
        },
        appStartupComplete: (state) => {
            state.started = true
        },
        incrementRegisCount: (state, action: PayloadAction<{ accountId: string, ACTION: T_ACTION_BY_SOCKET, ERRMSG: string }>) => {
            state.statusRegisterMF = action.payload.ACTION
            state.socketRegisAction[action.payload.accountId] = (state.socketRegisAction[action.payload.accountId] ? state.socketRegisAction[action.payload.accountId] : 0) + (action.payload.ACTION === 'CONFIRM' ? 1 : 0);
            if (action.payload.ACTION === 'REJECT') {
                state.msgSocketRegister = action.payload.ERRMSG
            }
        },
        setStatusSocket: (state, action: PayloadAction<any>) => {
            state.socketStatus = action.payload.status
        },
        setCosInfo: (state, action: PayloadAction<any>) => {
            state.cosInfo = action.payload.info
            state.setCosInfoStatus = true
        },
        setConfigCos: (state, action: PayloadAction<any>) => {
            state.cosConfig = action.payload.config
        },
        setStateLoading: (state, action: PayloadAction<{ state: boolean }>) => {
            state.stateLoading = action.payload.state
        },
        setStatusRegisterMF: (state, action: PayloadAction<{ status: string | null }>) => {
            state.statusRegisterMF = action.payload.status
        },
        setMsgSocketRegister: (state, action: PayloadAction<{ msg: string | null }>) => {
            state.msgSocketRegister = action.payload.msg
        },
        setIndustryData: (state, action: PayloadAction<{ industry: [] }>) => {
            state.industry = action.payload.industry
        },
        setDataNotificationSocket: (state, action: PayloadAction<{ status: T_ACTION_BY_SOCKET, msg: string | null, feature: string }>) => {
            state.statusNotificationBySocket = action.payload.status
            state.mgsNotificationBySocket = action.payload.msg
            state.featureSocketListener = action.payload.feature
        },
        resetDataNotificationSocket: (state) => {
            state.statusNotificationBySocket = null
            state.mgsNotificationBySocket = null
            state.featureSocketListener = null
        },
        setTheme: (state, action: PayloadAction<{ theme: string }>) => {
            state.theme = action.payload.theme
        },
        setLanguage: (state, action: PayloadAction<{ language: string }>) => {
            state.language = action.payload.language
        },
        setSaveVerify: (state, action: PayloadAction<{ status: boolean }>) => {
            state.saveVerify = action.payload.status
        },
    }
})

// Action creators are generated for each case reducer function
export const { initApp, appStartupComplete, incrementRegisCount,
    setStatusSocket, setCosInfo, setConfigCos, setStateLoading,
    setMsgSocketRegister, setStatusRegisterMF, setIndustryData, setDataNotificationSocket,
    resetDataNotificationSocket, setTheme, setLanguage, setSaveVerify,
} = appSlice.actions

export default appSlice.reducer